import * as actionTypes from "../actions/actionTypes";

const INITIAL_STATE = {
  filterConfig: {},
  filterConfigLoading: false,
  filterConfigError: null,

  listViewTabData: {},
  listViewLoading: false,
  listViewError: null,

  globalSearchTabData: {},
  globalSearchLoading: false,

  columnsChooserFields: {},
  columnsChooserFieldsLoading: false,
  columnsChooserFieldsError: null,
  selectedModule: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // List view data reducer cases
    case actionTypes.LIST_VIEW_REQUEST:
      return { ...state, listViewLoading: true };

    case actionTypes.LIST_GLOBAL_SEARCH_REQUEST:
      return { ...state, globalSearchLoading: true };

    case actionTypes.LIST_GLOBAL_SEARCH_SUCCESS:
      return {
        ...state,
        listViewError: null,
        globalSearchLoading: false,
        globalSearchTabData: {
          ...state.globalSearchTabData,
          ['globalSearch']: action.payload,
        },
      };

    case actionTypes.LIST_VIEW_SUCCESS:
      return {
        ...state,
        listViewError: null,
        listViewLoading: false,
        listViewTabData: {
          ...state.listViewTabData,
          [action.tab]: action.payload,
        },
      };

    case actionTypes.LIST_VIEW_FAILURE:
      return {
        ...state,
        listViewLoading: false,
        listViewError: action.error,
      };

    case actionTypes.SET_SELECTED_MODULE:
      return {
        ...state,
        selectedModule: action.payload,
      };

    case actionTypes.FILTER_CONFIG_REQUEST:
      return { ...state, filterConfigLoading: true };

    case actionTypes.FILTER_CONFIG_SUCCESS:
      return {
        ...state,
        filterConfig: {
          ...state.filterConfig,
          [action.module]: action.payload.data,
        },
        filterConfigError: null,
        filterConfigLoading: false,
      };

    case actionTypes.FILTER_CONFIG_FAILURE:
      return {
        ...state,
        filterConfigError: action.error,
        filterConfigLoading: false,
      };

    case actionTypes.GET_COLUMNSCHOOSER_FIELDS_REQUEST:
      return { ...state, columnsChooserFieldsLoading: true };

    case actionTypes.GET_COLUMNSCHOOSER_FIELDS_SUCCESS:
      return {
        ...state,
        columnsChooserFields: {
          ...state.columnsChooserFields,
          [action.module]: action.payload.data,
        },
        columnsChooserFieldsLoading: false,
        columnsChooserFieldsError: null,
      };

    case actionTypes.GET_COLUMNSCHOOSER_FIELDS_FAILURE:
      return {
        ...state,
        columnsChooserFieldsLoading: action.error,
        columnsChooserFieldsError: false,
      };

    default:
      return state;
  }
};
